import { Button } from '@/shared/ui/Button';
import { Typography } from '@/shared/ui/Typography/Typography';

import LinkArrowIcon from "@/assets/icons/linkArrow.svg?react";
import { useNavigate } from 'react-router-dom';
import { buildingType } from '@/entities/knowledge/model/types';
import { useAppSelector } from '@/app/store/hooks';
import { selectBuildingCategoryById } from '@/entities/home_content/model/selectors';

export interface IMainSectionProps {
    building?: buildingType,
    handleApplicationBtn: ()=>void
}

export function MainSection({ building, handleApplicationBtn }: IMainSectionProps) {

    const navigate = useNavigate()

    if (!building)
        return null

    const category = useAppSelector(selectBuildingCategoryById(building.direction))

    const handleScrollToFeedback = () => {
        const el = document.getElementById('feedback');
        if (el) {
            el.scrollIntoView({ behavior: 'smooth' });
        } else {
            navigate('/#feedback');
        }
    };

    return (
        <section className='w-full pt-[32px] pb-[12px] md:py-[32px]' >
            <div className='container px-[10px] md:px-[32px] 2xl:px-[180px] 3xl:px-[290px] flex flex-col gap-[20px] xl:gap-[24px]'>

                <div className='flex flex-row justify-between items-center'>
                    <Typography className='flex-1 text-[26px] font-semibold uppercase md:text-[30px] xl:text-[36px]'>
                        {category?.title}
                    </Typography>
                    <Typography className='
                        text-[#047918] pl-[10px] border-l border-l-[#047918] w-[150px] text-[10px]
                        md:text-[14px] md:w-[330px]
                        lg:w-[320px]
                    '>
                        Просторные офисы, развитая инфраструктура и престижное расположение
                    </Typography>
                </div>

                <div className='flex flex-col gap-[12px] xl:flex-row xl:items-center xl:justify-between'>

                    <Typography className='text-[14px] leading-[0.97em] font-[14px] xl:w-[105px] xl:text-right'>
                        Гибкие условия аренды и покупки
                    </Typography>

                    <Typography className='text-[44px] md:text-[60px] xl:text-[80px] leading-[0.97em] font-[300] uppercase'>
                        {building.name}
                    </Typography>

                    <Button
                        text='Заказать звонок'
                        bg='black'
                        className='text-[16px] h-[42px] pl-[24px] pr-[6px]'
                        onClick={handleApplicationBtn}
                        endIcon={<LinkArrowIcon className='w-[32px] h-[32px]' />}
                    />
                </div>

                <div
                    className='w-full bg-no-repeat bg-cover bg-center rounded-[20px] h-[400px] p-[12px] xl:p-[20px]
                        md:h-[500px] md:px-5 md:py-[30px]
                    '
                    style={{ backgroundImage: `url(${building.imageUrl || '/images/knowledge_default_bg.png'})` }}
                >
                    <div className='flex flex-col w-full h-full justify-between items-center sm:flex-row sm:h-min'>
                        <div className='flex flex-row items-center gap-[12px] px-[20px] py-[8px] border border-black w-min rounded-full min-w-[224px]'>
                            <Typography className='uppercase whitespace-nowrap w-max text-[20px] font-semibold'>
                                КЛАСС {building.class.grade}
                            </Typography>

                            <div className='flex h-8 w-px bg-black ' />

                            <Typography className='min-w-[160px] text-[12px] font-[400]'>
                                {building.class.description}
                            </Typography>
                        </div>

                        <div className='flex gap-[12px]'>
                            <Typography className='text-[14px] font-[400] blur-cls shadow-cls p-[10px] rounded-full'>
                                Готовность {building.yearBuilt} г
                            </Typography>
                            <Typography className='text-[14px] font-[400] blur-cls shadow-cls p-[10px] rounded-full'>
                                Район {building.district}
                            </Typography>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
